import React from 'react';
import SectionHeader from '../ui/SectionHeader';
import FeatureBox from '../features/FeatureBox';
import FadeIn from '../ui/FadeIn';
import { IconCheckBadge, IconCoins, IconShield, IconTruck } from '../ui/Icons';

const WhyChooseUsSection = () => {
  const features = [
    {
      id: 1,
      icon: <IconCheckBadge />,
      title: 'Quality Checked',
      description: 'Every car passes a 150-point inspection before it goes on the forecourt.'
    },
    {
      id: 2,
      icon: <IconCoins />,
      title: 'Fair Pricing',
      description: 'Transparent, market-checked pricing with flexible finance — no hidden extras.'
    },
    {
      id: 3,
      icon: <IconShield />,
      title: 'Warranty Included',
      description: 'Drive away with warranty cover as standard, wherever the road takes you.'
    },
    {
      id: 4,
      icon: <IconTruck />,
      title: 'Free Delivery',
      description: 'We deliver anywhere within 200 miles of Romford — free of charge.'
    }
  ];

  return (
    <section className="why-section" id="services">
      <div className="container">
        <FadeIn>
          <SectionHeader
            eyebrow="The JAC Cars Difference"
            title="Why Buy From JAC Cars"
            subtitle="No hard sell — just honest cars, checked properly and priced fairly"
          />
        </FadeIn>
        <div className="features-grid">
          {features.map(feature => (
            <FadeIn key={feature.id}>
              <FeatureBox {...feature} />
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUsSection;
